import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class MessageService {
    private static onSuccess: ((message) => any)[];
    private static onError: ((message) => any)[];

    constructor(private translate: TranslateService) {
    }

    success(message: string): void {
        for(let index in MessageService.onSuccess) {
            MessageService.onSuccess[index](message);
        }
    }

    deleted() {
        this.success("Common.Deleted");
    }

    error(message: string): void {
        for(let index in MessageService.onError) {
            MessageService.onError[index](message);
        }
    }

    errorByMessageId(messageId: number): void {
        this.error("Messages." + messageId);
    }

    addOnSuccess(callback: (message) => void) {
        if (typeof(MessageService.onSuccess) == 'undefined') {
            MessageService.onSuccess = [];
        }

        MessageService.onSuccess.push(callback);
    }

    addOnError(callback: (message) => void) {
        if (typeof(MessageService.onError) == 'undefined') {
            MessageService.onError = [];
        }

        MessageService.onError.push(callback);
    }
}
